import { Chip } from '@mui/material'
import React from 'react'

interface ExtractionConfidenceBadgeProps {
  confidence: 'high' | 'medium' | 'low' | 'not_found'
}

const confidenceConfig = {
  high: { label: 'High', color: '#4caf50', bgColor: '#e8f5e9' },
  medium: { label: 'Medium', color: '#ff9800', bgColor: '#fff3e0' },
  low: { label: 'Low', color: '#f44336', bgColor: '#ffebee' },
  not_found: { label: 'Not detected', color: '#9e9e9e', bgColor: '#f5f5f5' },
}

export const ExtractionConfidenceBadge: React.FC<ExtractionConfidenceBadgeProps> = ({ confidence }) => {
  const config = confidenceConfig[confidence] || confidenceConfig.not_found

  return (
    <Chip
      label={config.label}
      size="small"
      sx={{
        backgroundColor: config.bgColor,
        color: config.color,
        fontWeight: 600,
        fontSize: '0.7rem',
        height: 20,
      }}
    />
  )
}
